import type { CreditCardsType } from '@libs/core';

const ADYEN_BRANDS: Record<CreditCardsType, string> = {
    Amex: 'amex',
    Discover: 'discover',
    Mastercard: 'mc',
    mc: 'mc',
    Visa: 'visa',
};

/** Adyen needs the brand of a stored card to know the CVC length (4 digits for Amex, 3 otherwise). */
export function getAdyenBrand(cardType: CreditCardsType): string {
    return ADYEN_BRANDS[cardType] ?? cardType.toLowerCase();
}

export function getCardBrandName(cardType: CreditCardsType): string {
    return cardType === 'mc' ? 'Mastercard' : cardType;
}
